// removed by extract-text-webpack-plugin
module.exports = {"deviceInfoTab4":"t7gwpmmX3wt0AvkvmXYue","btn":"_3kWVohbMm8OTieq6xFZ3gL","stepsContainer":"_7-yVw3Y4jLf3Bcc5-ITCw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceInfo/DeviceControl.less
// module id = 1582
// module chunks = 0